import {useListView} from '../../core/ListViewProvider'
import {PlanListSearchComponent} from './PlanListSearchComponent'
import {PlanListToolbar} from './PlanListToolbar'

const PlanListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <PlanListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        <PlanListToolbar />
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {PlanListHeader}
